import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getContributeStoryResult: host + 'reportResult/getContributeStoryResult',//投稿统计
};

export const getContributeStoryResult = (body, callBack) => {  //投稿统计
    request({url:Apis.getContributeStoryResult, body, callBack});
};